import { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import { ProductServices } from "../../../services/products";
import { useAsync } from "../../../utils/hooks/useAsync";
import Loading from "../../common/Loading";
import { ScrollToTopOnMount } from "../../common/ScrollToTopOnMount";
import { AdminService } from "../utils";
import AddCategory from "./AddCategory";
import CategoryList from "./CategoryList";

const AdminCategoryContainer = () => {
  const { isSuccess, isLoading, run } = useAsync();
  const [categories, setCategories] = useState<Category[]>([]);
  const [processingNewCategory, setProcessingNewCategory] =
    useState<boolean>(false);

  useEffect(() => {
    !processingNewCategory &&
      run(
        ProductServices.getAllCategories().then((r) => {
          setCategories(r.data);
        })
      );
  }, [, processingNewCategory]);

  const submitNewCategory = (newCategory: Category) => {
    setProcessingNewCategory(true);
    run(
      AdminService.createNewCategory(newCategory).then((r: any) => {
        toast.success("Categoría agregada");
        setProcessingNewCategory(false);
      })
    );
  };

  const deleteCategory = (department: string, value: string, id: string) => {
    setProcessingNewCategory(true);
    run(AdminService.deleteCategory({ department, value, id })).then(
      (r: any) => {
        if (r.exist.deletedCount == -1) {
          toast.warning("Categoría con productos vinculados");
          setProcessingNewCategory(false);
        } else {
          toast.success("Categoría eliminada");
          setProcessingNewCategory(false);
        }
      }
    );
  };
  const updateCategory = async (category: Category) => {
    setProcessingNewCategory(true);
    run(
      AdminService.updateCategory(category).then((r: any) => {
        toast.success("Categoría actualizada");
        setProcessingNewCategory(false);
      })
    );
  };

  return (
    <>
      <ScrollToTopOnMount></ScrollToTopOnMount>
      <ToastContainer autoClose={1500} position={"bottom-left"} />
      {categories && isSuccess && (
        <AddCategory
          categories={categories}
          submitNewCategory={submitNewCategory}
        />
      )}
      {categories && isSuccess && !processingNewCategory && (
        <CategoryList
          categories={categories}
          deleteCategory={deleteCategory}
          updateCategory={updateCategory}
        />
      )}
      {isLoading && <Loading />}
    </>
  );
};

export default AdminCategoryContainer;
